import { forwardRef, ForwardRefRenderFunction, Fragment } from 'react';
import { Box } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import { OnboardingPlanDisplay } from '../../../../types';
import Row from './components/Row';
import locales from './locales';
import sections from './sections';

interface PlanDetailsProps {
  onboardingPlans: OnboardingPlanDisplay[];
}

const PlanDetails: ForwardRefRenderFunction<
  HTMLSpanElement,
  PlanDetailsProps
> = ({ onboardingPlans }, ref) => (
  <>
    {sections.map((section, sectionIndex) => {
      const isFirstSection = sectionIndex === 0;
      const isLastSection = sectionIndex === sections.length - 1;
      return (
        <Fragment key={section.key}>
          <Box gridColumnEnd={-1} gridColumnStart={1}>
            {isFirstSection ? <span ref={ref}></span> : null}
            <Text
              fontWeight="500"
              marginBottom="space-16"
              marginTop="space-40"
              size="md"
              variant="light"
            >
              {locales.sections[section.key].toUpperCase()}
            </Text>
          </Box>

          {section.rows.map(
            ({ getCellData, isComing, isNew, key }, rowIndex) => {
              const isLastRow = rowIndex === section.rows.length - 1;
              const { subtitle, title } = locales.rows[key];
              return (
                <Row
                  getCellData={getCellData}
                  isComing={isComing}
                  isLast={isLastSection && isLastRow}
                  isNew={isNew}
                  key={key}
                  onboardingPlans={onboardingPlans}
                  subtitle={subtitle}
                  title={title}
                />
              );
            },
          )}
        </Fragment>
      );
    })}
  </>
);

export default forwardRef(PlanDetails);
